"use client";

import { toLink } from "@/contents/converters/links"
import { NavItem } from "@/contents/sanityTypes"

import MenuNavItem from "@/ui/layout/Menu/MenuNavItem"
import { usePathname, useRouter } from "next/navigation"

export interface NavItemProps {
  item: NavItem
  onClick?: () => void
}

const SanityNavItem = ({ item, onClick }: NavItemProps) => {
  const path = usePathname()

  const linkData = toLink(item.link)
  if (!linkData) {
    return <></>
  }

  return (
    <MenuNavItem
      label={item.label}
      link={linkData.url}
      anchor={linkData?.anchor}
      onClick={onClick}
      active={linkData.url === path}
    />
  )
}

export default SanityNavItem
